export default __webpack_public_path__ + "static/media/searchicon.57b683f3.svg";